var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0625 5.1875V57.0625C57.0625 58.4383 56.516 59.7578 55.5431 60.7306C54.5703 61.7035 53.2508 62.25 51.875 62.25H38.9062C37.5304 62.25 36.211 61.7035 35.2381 60.7306C34.2653 59.7578 33.7188 58.4383 33.7188 57.0625V5.1875C33.7188 3.81169 34.2653 2.49223 35.2381 1.51938C36.211 0.546538 37.5304 0 38.9062 0H51.875C53.2508 0 54.5703 0.546538 55.5431 1.51938C56.516 2.49223 57.0625 3.81169 57.0625 5.1875ZM18.1562 0H5.1875C3.81169 0 2.49223 0.546538 1.51938 1.51938C0.546538 2.49223 0 3.81169 0 5.1875V57.0625C0 58.4383 0.546538 59.7578 1.51938 60.7306C2.49223 61.7035 3.81169 62.25 5.1875 62.25H18.1562C19.5321 62.25 20.8515 61.7035 21.8244 60.7306C22.7972 59.7578 23.3438 58.4383 23.3438 57.0625V5.1875C23.3438 3.81169 22.7972 2.49223 21.8244 1.51938C20.8515 0.546538 19.5321 0 18.1562 0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.cb714b9afce308dcea1336abb9d8c6af.svg";
export { ForwardRef as ReactComponent };